import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Table from "../../core/common/dataTable/index";
import pdf from "../../assests/pdf/10-page-sample.pdf";
import useUserData from "../../custom_hooks/useUserData";
import axiosInstance from "../../API/axiosConfig";
import webserviceUrl from "../../API/webserviceUrl";
import { McitiImg } from "../../utils/iconLogo";
import LoadingGreen from "../loading/LoadingGreen";

const tableData = [
  {
    sno: "1",
    unit: "Unit 1",
    topic: "Introduction to AI",
    school_name: "IHFC School",
    lesson_pdf_path: pdf,
  },
  {
    sno: "2",
    unit: "Unit 2",
    topic: "Machine Learning Basics",
    school_name: "IHFC School",
    lesson_pdf_path: "",
  },
  {
    sno: "3",
    unit: "Unit 3",
    topic: "Data Handling",
    school_name: "IHFC School",
    lesson_pdf_path: pdf,
  },
];

const Training = () => {
  // const schoolCode = "SCH123";
  const { employee_id, school_code, course } = useUserData();
  const [lessonUnits, setLessonUnits] = useState<any>([]);
  const [resError, setResError] = useState({});
  const [loading, setLoading] = useState(true);
  // const [selectedCohort, setSelectedCohort] = useState("Summer Cohort 2026");
  // const cohortOptions = [
  //   "Summer Cohort 2026",
  //   "Winter Cohort 2025",
  //   "Spring Cohort 2025",
  // ];

  let cohort = localStorage.getItem("cohort");
  console.log(cohort, "pressings");

  //  const [cohort, setcohort] = useState<any>({});
  const [cohortLoading, setCohortLoading] = useState(false);
  const [cohortOptions, setCohortOptions] = useState([]);
  const [selectedCohort, setSelectedCohort] = useState<string>("");

  console.log(cohortOptions);

  // Fetch batches and use them as the cohort dropdown options
  const getCohorts = async () => {
    if (!school_code) return; // safety check
    try {
      setCohortLoading(true);
      const resp = await axiosInstance.post(webserviceUrl.get_batches, {
        employee_id,
        school_code,
      });

      const batchData = resp?.data?.data || [];
      setCohortOptions(batchData);
    } catch (error) {
      console.error("Error fetching cohorts:", error);
    } finally {
      setCohortLoading(false);
    }
  };

  useEffect(() => {
    getCohorts();
  }, [school_code]);

  const columns = [
    {
      title: "SNo.",
      dataIndex: "sno",
      render: (text: string, render: any, index: number) => <p>{index + 1}</p>,
    },
    {
      title: "Unit Name",
      dataIndex: "unit",
    },
    {
      title: "Training Topic",
      dataIndex: "topic",
    },
    {
      title: "Program Name",
      dataIndex: "course_name",
    },
    {
      title: "Start Session",
      dataIndex: "lesson_pdf_path",
      render: (_: any, row: any) => (
        <div style={{ marginRight: "10px" }}>
          {row?.lesson_pdf_path !== "" ? (
            <Link
              className="start-link btn btn-success"
              to="/view-pdf"
              state={{ row, school_code }}
              onClick={() => {
                localStorage.setItem("schoolCode", school_code ?? "");
                localStorage.setItem("pdfData", JSON.stringify(row));
              }}
            >
              Start Session
            </Link>
          ) : (
            <p className="text-danger">No File Available</p>
          )}
        </div>
      ),
    },
  ];

  const getLessonUnits = async () => {
    try {
      setLoading(true);
      setResError({});
      const resp = await axiosInstance.post(webserviceUrl.get_lesson_units, {
        school_code: school_code,
        employee_id: employee_id,
        participant_type: course?.level,
        participant_tier: course?.class,
        course_group: course?.combination_code,
        batch_no: course?.section,
        academic_year: course?.academic_year,
        semester: course?.semester,
      });
      // console.log(resp)
      if (resp?.data?.success) {
        const unitData = resp?.data?.data || [];
        const processed = unitData.map((item: any, index: number) => ({
          ...item,
          key: index + 1, // Or use item.lesson_plan_id if it's guaranteed unique
        }));

        setLessonUnits(processed);
      } else {
        setResError(resp?.data?.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => setLoading(false), 500);
    }
  };

  useEffect(() => {
    if (course && Object.keys(course)?.length > 0) {
      getLessonUnits();
    }
  }, [course]);

  // console.log(course)
  // console.log(course)
  // console.log(lessonUnits)

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div>
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Training Sessions</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={all_routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Teacher</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Training Sessions
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
                <div className="ms-2 head-icons">
                  <CollapseHeader />
                </div>
              </div>
            </div>
            {/* Cohort switcher */}
            <div className="mb-2">
              <div className="dropdown">
                <button
                  type="button"
                  className="btn btn-outline-light bg-white border d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  disabled={cohortLoading || cohortOptions.length === 0}
                  style={{
                    minWidth: "220px",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <i className="ti ti-users me-2 text-primary" />
                    <span className="me-1 text-truncate">
                      {cohortLoading
                        ? "Loading cohorts..."
                        : selectedCohort || "Select cohort"}
                    </span>
                  </div>
                  <i className="ti ti-chevron-down ms-1" />
                </button>
                <ul className="dropdown-menu dropdown-menu-end p-2">
                  {cohortOptions.map((cohort: any) => (
                    <li key={cohort}>
                      <button
                        type="button"
                        className={`dropdown-item rounded d-flex align-items-center justify-content-between${
                          cohort === selectedCohort ? " active" : ""
                        }`}
                        onClick={() => {
                          setSelectedCohort(cohort?.course_name);
                          localStorage.setItem("cohort", cohort);

                          localStorage.setItem(
                            "batch",
                            btoa(JSON.stringify(cohort)),
                          );

                          localStorage.setItem(
                            "cohort",
                            JSON.stringify(cohort),
                          );
                          getLessonUnits();
                          // setcohort(cohort);
                        }}
                      >
                        {cohort?.course_name}
                        {cohort?.course_name === selectedCohort && (
                          <i className="ti ti-check" />
                        )}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* /Breadcrumb */}

          <div className="card">
            <div className="card-body p-3 ">
              <div className="mb-2 d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <h5>Training List</h5>
              </div>
              {loading ? (
                <LoadingGreen size="40" paddingTop="25px" />
              ) : (
                <Table
                  dataSource={lessonUnits}
                  // dataSource={tableData}
                  columns={columns}
                  Selection={false}
                />
              )}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="footer d-smflex d-flex align-items-center justify-content-center border-top bg-white p-3 pb-0 pt-2">
          <p className="mb-0">
             Organized by IHFC, IIT 
            {/* <img
              src={McitiImg}
              alt="Mciti Logo"
              className="ms-2 "
              style={{
                height: "40px",
                width: "40px",
                objectFit: "contain",
              }}
            /> */}
          </p>
          {/* <p className="mb-0"> © {new Date()?.getFullYear()} IHFC. All rights reserved.</p> */}
        </div>
      </div>
    </>
  );
};

export default Training;
